export default function BrandName({ size = 'text-2xl', className = '' }) {
  return (
    <span translate="no" className={`font-bold uppercase tracking-tighter ${size} ${className}`} style={{ fontFamily: 'Teko, sans-serif' }}>
      <span className="text-white">MOTO</span><span className="text-red-500">VELOZ</span>
    </span>
  );
}
